import OwlCarousel from 'react-owl-carousel'

import vendor1 from '../../assets/images/logos/vendor-1.png'
import vendor2 from '../../assets/images/logos/vendor-7.png'
import vendor3 from '../../assets/images/logos/vendor-3.png'
import vendor5 from '../../assets/images/logos/vendor-5.png'
import vendor6 from '../../assets/images/logos/vendor-6.png'
import vendor7 from '../../assets/images/logos/vendor-2.png'
import vendor8 from '../../assets/images/logos/vendor-8.png'
import vendor9 from '../../assets/images/logos/vendor-9.png'
import vendor10 from '../../assets/images/logos/vendor-10.png'

function Logos() {
    return ( 
        <div className="container-fluid wow fadeInUp" data-wow-delay="0.1s">
            <div className="container py-5 mb-5">
                <div className="bg-white">
                    <OwlCarousel className="vendor-carousel owl-centered" loop margin={45} dots={false} 
                    autoplay={true} smartSpeed={1000}
                    responsive={
                        {
                            0:{
                                items:2
                            },
                            576:{
                                items:4
                            },
                            768:{
                                items:6
                            },
                            992:{
                                items:8
                            }
                        }
                    }>
                        <img className='vendor-item' src={vendor1} alt="partner-logo"/>
                        <img className='vendor-item' src={vendor2} alt="partner-logo"/>
                        <img className='vendor-item' src={vendor3} alt="partner-logo"/>
                        <img className='vendor-item' src={vendor5} alt="partner-logo"/>
                        <img className='vendor-item' src={vendor6} alt="partner-logo"/>
                        <img className='vendor-item' src={vendor7} alt="partner-logo"/>
                        <img className='vendor-item' src={vendor8} alt="partner-logo"/>
                        <img className='vendor-item' src={vendor9} alt="partner-logo"/>
                        <img className='vendor-item' src={vendor10} alt="partner-logo"/>
                    </OwlCarousel>
                </div>
            </div>
        </div>
     );
}

export default Logos;